import { apiPost } from "./client";
import { useApiMutation } from "./queryHooks";

export default async function Posts(params, route) {
    return apiPost(route, params);
}

export function usePostMutation(route, options = {}) {
    return useApiMutation({
        route,
        request: apiPost,
        mutationKeyPrefix: "POST",
        options,
    });
}
